import React from 'react';
import CartData from './cartData';
import CompareCartData from './CompareCartData'
import { connect } from 'react-redux'
import * as cartActions from './../../action/cart'
import { updateSCTags } from './../../service/dtmTag';
import * as modalAction from './../../action/modalWindow';
import ModalOverlay from './../../components/modalOverlay';
import { ModalWindow } from './../../constants/actionType';

class CartJSON extends React.PureComponent {
    constructor(props) {
        super(props);
        this.cartUpdated = "cart-update";
        this.state = { carttype: "new", disableCart: "" };
        this.isReskin = this.props?.buildProductState?.isReskin && this.props?.lqState?.runtimeKey?.EnableReskin === 'Y';
        this.isMonarch = this.props?.isMonarch ? this.props.isMonarch : (this.props.buildProductState?.isMonarchView || true);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.buildProductState.isReskin !== this.props.buildProductState.isReskin){
            this.isReskin = nextProps.buildProductState.isReskin && this.props.lqState.runtimeKey.EnableReskin === 'Y';
        }
    }

    enableCart = () => {
        this.setState({ disableCart: "" });
    }

    onCartClick = (id = "") => {
        if (id === "existingCart") {
            if (this.state.disableCart === "") {
                this.setState({ disableCart: "new" });
            } else {
                this.setState({ disableCart: "" });
            }
            //this.state.carttype = "existing";
            this.setState({ carttype: "existing" });
            if (!this.props.profileCart.isProfileCartOpen) {
                updateSCTags("cart open")
            }
            else {
                cartActions.splitBillTab(0, this.props.dispatch)
            }
            cartActions.cartToggle(this.state.carttype, this.props.dispatch, this.props.appState.visitId,this.props.buildProductState)
        } else if (id === "newCart") {
            if (this.state.disableCart === "") {
                this.setState({ disableCart: "existing" });
            } else {
                this.setState({ disableCart: "" });
            }
            // this.state.carttype = "new";
            this.setState({ carttype: "new" });
            if (!this.props.cart.isCartOpen) {
                updateSCTags("cart open")
            }
            else {
                cartActions.splitBillTab(0, this.props.dispatch)
            }
            cartActions.cartToggle(this.state.carttype, this.props.dispatch, this.props.appState.visitId,this.props.buildProductState)
        }
    }

    onOpenModel = (e) => {
        modalAction.openModalWindow(e.target.id, this.props.dispatch);
    }

    render() {
        let TotalPrice = "$0";
        let OneTimePrice = "0";
        let ProfileTotalPrice = "$0";
        let ProfileOneTimePrice = "0";
        let comparePriceLayout = '';
        const { disableCart } = this.state;
        let isNCMVAppFlow = this.props.signIn?.isNCMVAppFlow ?? false;

        if (this.props.cart.cartHeader !== null && this.props.cart.cartHeader !== undefined && this.props.cart.cartHeader.length > 0) {
            TotalPrice = this.props.cart.cartHeader[0].monthlyRcPrice !== null ? this.props.cart.cartHeader[0].monthlyRcPrice : '';
            if (this.cartUpdated === "cart-update")
                this.cartUpdated = "";
            else if (this.props.appState?.currentPage?.pathname?.indexOf('buildproduct') > -1 && this.cartUpdated === "" && this.props.appState.isLoader.loaderCount === 0 && this.props.cart.isCartUpdated) {
                this.cartUpdated = "cart-update";
                setTimeout(() =>
                    this.props.dispatch({ type: 'ISCARTUPDATED', value: false }), 1000);

            }
        }

        if (this.props.cart.cartHeader !== null && this.props.cart.cartHeader !== undefined && this.props.cart.cartHeader.length > 0) {
            if (this.props.cart.cartData !== null && this.props.cart.cartData.length > 0 && this.props.cart.cartData[0].oneTimeCharge !== undefined && this.props.cart.cartData[0].oneTimeCharge.onetimecharge !== undefined) {
                this.props.cart.cartData[0].oneTimeCharge.onetimecharge.map((obj) => {
                    if (obj.price !== null && obj.price !== undefined && obj.price !== "Fee Waived" && obj.price !== "Included" && obj.bundleActucalPrice !== null && obj.bundleActucalPrice !== undefined) {
                        if (obj.maxInstallments !== null && obj.maxInstallments !== undefined) {
                            if (obj.maxInstallments === 1) {
                                let price = obj.price;
                                price = price.substring(1, price.length);
                                OneTimePrice = parseFloat(OneTimePrice) + parseFloat(price);
                            }
                            else {
                                OneTimePrice = parseFloat(OneTimePrice) + parseFloat(obj.bundleActucalPrice);
                            }
                        }
                    }
                });
            }
        }
        const oneTimePrice_Float = parseFloat(OneTimePrice);  // to avoid $NaN being displayed in cart container
        OneTimePrice = oneTimePrice_Float ? "$" + oneTimePrice_Float.toFixed(2) : '$0.00' ; // to avoid $NaN being displayed in cart container

        // OneTimePrice = "$" + parseFloat(OneTimePrice).toFixed(2);

        if (this.props.profileCart.cartHeader !== null && this.props.profileCart.cartHeader !== undefined && this.props.profileCart.cartHeader.length > 0) {
            ProfileTotalPrice = this.props.profileCart.cartHeader[0].monthlyRcPrice !== null ? this.props.profileCart.cartHeader[0].monthlyRcPrice : '';
            if (this.cartUpdated === "cart-update")
                this.cartUpdated = "";
            else if (this.props.appState?.currentPage?.pathname?.indexOf('buildproduct') > -1 && this.cartUpdated === "" && this.props.appState.isLoader.loaderCount === 0 && this.props.profileCart.isCartUpdated) {
                this.cartUpdated = "cart-update";
                setTimeout(() =>
                    this.props.dispatch({ type: 'ISCARTUPDATED', value: false }), 1000);

            }
        }

        if (this.props.profileCart.cartHeader !== null && this.props.profileCart.cartHeader !== undefined && this.props.profileCart.cartHeader.length > 0) {
            if (this.props.profileCart.cartData !== null && this.props.profileCart.cartData.length > 0 && this.props.profileCart.cartData[0].oneTimeCharge !== undefined && this.props.profileCart.cartData[0].oneTimeCharge.onetimecharge !== undefined) {
                this.props.profileCart.cartData[0].oneTimeCharge.onetimecharge.map((obj) => {
                    if (obj.price !== null && obj.price !== undefined && obj.price !== "Fee Waived" && obj.bundleActucalPrice !== null && obj.bundleActucalPrice !== undefined) {
                        if (obj.maxInstallments !== null && obj.maxInstallments !== undefined) {
                            if (obj.maxInstallments === 1) {
                                let price = obj.price;
                                price = price.substring(1, price.length);
                                ProfileOneTimePrice = parseFloat(ProfileOneTimePrice) + parseFloat(price);
                            }
                            else {
                                ProfileOneTimePrice = parseFloat(ProfileOneTimePrice) + parseFloat(obj.bundleActucalPrice);
                            }
                        }
                    }
                });
            }
        }
        ProfileOneTimePrice = "$" + parseFloat(ProfileOneTimePrice).toFixed(2);
        let cartData = "";
        let profileCartData = "";
        if (this.state.carttype === "new") {
            if (this.props.cart.isCartOpen) {
                if (this.props.cart.cartData !== null) {
                    cartData = (this.props?.appState?.flowType ==='MV' ) ? '':<CartData ctype={this.state.carttype} cartenable={this.enableCart} />
                } else {
                    this.props.cart.isCartOpen = false;
                }
            }
        } else if (this.state.carttype === "existing") {
            if (this.props.profileCart.isProfileCartOpen) {
                if (this.props.profileCart.cartData !== null) {
                    profileCartData = <CartData ctype={this.state.carttype} cartenable={this.enableCart}> </CartData>
                } else {
                    this.props.profileCart.isProfileCartOpen = false;
                }
            }
        }

        if (this.props.modalWindow.modalId === ModalWindow.ids.comparePrice) {
            comparePriceLayout = <CompareCartData profileCart={this.props.profileCart} newCart={this.props.cart} />;
        }

        let showCompareCart = this.props.cart.cartData && this.props.cart.cartData[0] && this.props.cart.cartData[0].serviceHeaders

        let cartClass = `${this.isMonarch ? 'text-black' : 'text-white'} text-normal text-right small-padding-vert-zero small-padding-top-zero tiny-padding-vert-micro tiny-padding-top-medium bold block relative`
        if(isNCMVAppFlow == true){
            cartClass = cartClass + " mvapp-cart";
        }
        const isMobile = (window.screen.width < 768) ? true : false; 
        const hideOTCMVMiniCartRskn = this.props?.appState?.flowType ==='MV';
        return (
            <div className="row rightRow">
                <div className={(ProfileTotalPrice.indexOf("$0") > -1 && !( this.props.cart && this.props.cart.cartData && this.props.cart.cartData.length > 0 && this.props.cart.cartData[0] && this.props.cart.cartData[0].serviceHeaders && this.props.cart.cartData[0].serviceHeaders.length != 0)) || (this.props.appState.flowType==='MV' && this.props.buildProductState.movesstickyheaderfooter)? "hide" : ("columns relative pointer  " + (disableCart === "existing" ? "disabled" : ""))}>
                    <div id="cartmaindiv1" >                                        
                        <div className={ (window.location.pathname !== "/inhome/moves/ordersummary"  && showCompareCart && !(hideOTCMVMiniCartRskn && isMobile )) ? "" : "hide"}>
                            {!isNCMVAppFlow &&
                                <p onClick={(e) => this.onOpenModel(e)} className={!this.isReskin ? `tiny-margin-horiz-zero text-normal oldCartText ${this.isMonarch ? 'text-black' : 'text-white'} ${(this.props.appState.flowType==='MV' && this.props.buildProductState.movesstickyheaderfooter) ? 'hide' : ''} comparePlans` : `tiny-margin-horiz-zero ${this.isMonarch ? 'text-black' : 'text-white'} ${(this.props.appState.flowType==='MV' && this.props.buildProductState.movesstickyheaderfooter) ? 'hide' : ''} comparePlansRskn comparePlansTitleRskn`} id="COMPAREPRICE">
                                    {!this.isReskin ? 
                                        "Compare your new & current plan "
                                    :
                                        "Compare plans"
                                    }
                                    <span className={`verizon-icons small Icon--save ${this.isMonarch ? 'text-black' : 'text-white'} middle`} id="COMPAREPRICE"></span>
                                </p>
                            }
                            {isNCMVAppFlow &&
                                <p onClick={(e) => this.onOpenModel(e)} className={`tiny-margin-horiz-zero text-normal oldCartText ${this.isMonarch ? 'text-black' : 'text-white'} ${(this.props.appState.flowType==='MV' && this.props.buildProductState.movesstickyheaderfooter) ? 'hide' : ''} mvapp-compare-plan`} id="COMPAREPRICE">Compare with current plan <span className="" id="COMPAREPRICE"></span></p>
                            }

                            <ModalOverlay className={`vzicon small ${this.isMonarch ? 'text-black' : 'text-white'} middle`} template={comparePriceLayout} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>
                        </div>                        
                    </div>
                </div>
                <div className={(TotalPrice.indexOf("$0") > -1 && !( this.props.cart && this.props.cart.cartData && this.props.cart.cartData.length > 0 && this.props.cart.cartData[0] && this.props.cart.cartData[0].serviceHeaders && this.props.cart.cartData[0].serviceHeaders.length != 0)) || (this.props.appState.flowType==='MV' && this.props.buildProductState.movesstickyheaderfooter) ? "hide" : ""}>
                    {/* <p className="padding-horiz-zero bold tiny-margin-horiz-zero text-normal oldCartText">Your New plan</p> */}
                    <div id="cartmaindiv">                        
                        <div className="more left inline-block topnav_cart" id="Billcart">
                            <div onClick={() => this.onCartClick("newCart")} className={"pointer " + this.cartUpdated} role="button" id="BillCartTop" tabIndex="0" onKeyDown={(e) => this.handleKeyDown(e)}>
                                <div className={cartClass} data-final-cart="" tabIndex="0" aria-hidden="false" id="totalAmt" data-cs-mask>
                                    {!this.isReskin ? 
                                        <b data-cart-value="">{TotalPrice}/mo</b>
                                    :
                                        <span data-cart-value="" className="tileSubtextReskin">{TotalPrice}/mo.</span>
                                    }
                                    <span className={`verizon-icons small Icon--shopping-bag ${this.isMonarch ? 'text-black' : 'text-white'} middle`} id="newCart" aria-hidden="true"></span>
                                    {(!isNCMVAppFlow && !this.isReskin) &&
                                        <span className="vzicon smallChevron cart-icon icon-chevron-down" id="newCart" aria-hidden="true"></span>
                                    }
                                    <span className="updateText">Cart Updated</span>
                                </div>
                            </div>
                            <div className={`${this.isMonarch ? 'text-black' : 'text-white'} text-right normal-weight text-small onetime`} id="PlusText1" aria-hidden="false"></div>
                            <div className={(OneTimePrice === '$0' || OneTimePrice === '$0.00' || hideOTCMVMiniCartRskn) ? 'hide' : `${this.isMonarch ? 'text-black' : 'text-white'} text-right text-small normal-weight tiny-padding-vert-micro`} id="PlusText2" tabIndex="0" aria-hidden="true">Plus <strong>{OneTimePrice}</strong> one-time charges</div>
                            <div id="divTryMeOfferText" className={`${this.isMonarch ? 'text-black' : 'text-white'} text-small text-right normal-weight hide`}>Price starting month 3</div>
                            {cartData}
                        </div>                        
                    </div>
                </div>

                {/* {this.props.appState.flowType==='MV' && this.props.buildProductState.movesstickyheaderfooter && this.props.modalWindow.modalId === 'COMPAREPRICE' ? <ModalOverlay className={`vzicon small ${this.isMonarch ? 'text-black' : 'text-white'} middle`} template={comparePriceLayout} modalWindow={this.props.modalWindow} dispatch={this.props.dispatch}></ModalOverlay>:''} */}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        lqState: state.loopQual,
        appState: state.app,
        cart: state.cart,
        profileCart: state.profileCart,
        modalWindow: state.modalWindow,
        moveState: state.moveExp,
        signIn: state.signIn,
        buildProductState: state.buildProduct
    }
}

export default connect(
    mapStateToProps,
)(CartJSON);